import { User, UserFilters, QueryResult } from '@/type';
import api from '@/API';

export default {
  find(id: number): Promise<User> {
    return api
      .get(`users/${id}`)
      .then(response => response.data);
  },
  findAll(accountId: number, filters?: UserFilters): Promise<QueryResult> {
    return api
      .get('users', { params: { ...filters, accountId } })
      .then(response => response.data);
  },
  count(accountId: number): Promise<number> {
    return this.findAll(accountId).then(result => result.total);
  },
  findByClient(clientId: number): Promise<User> {
    return api
      .get('users', { params: { clientId } })
      .then((response) => {
        if (response.data.items.length === 1) {
          return response.data.items[0];
        }
        throw new Error(`No user with Client ID ${clientId} found.`);
      });
  },
};
